import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'

const CheckSujetosObligados = ({ sujetosObligadosCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details =
    sujetosObligadosCheck?.checkDetails && sujetosObligadosCheck?.checkDetails?.results
      ? sujetosObligadosCheck?.checkDetails?.results
      : []
  const hasChecks = Array.isArray(details) && details.length > 0
  const checkLength = hasChecks ? details.length : 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:sujetosObligados')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={sujetosObligadosCheck?.email}
        status={sujetosObligadosCheck?.status}
        createdAt={sujetosObligadosCheck?.createdAt}
        updatedAt={sujetosObligadosCheck?.updatedAt}
      />

      {!hasChecks && sujetosObligadosCheck?.checkDetails?.info && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle3">{sujetosObligadosCheck?.checkDetails?.info}</Typography>
        </Paper>
      )}

      {hasChecks &&
        details.map((detail, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">CUIT</Typography>
                  <Typography variant="subtitle3">{detail.cuit ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:subjectType')}</Typography>
                  <Typography variant="subtitle3">{detail.tipoSujeto ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:status')}</Typography>
                  <Typography variant="subtitle3">{detail.estado ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:message')}</Typography>
                  <Typography variant="subtitle3">{detail.mensaje ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:createdAt')}</Typography>
                  <Typography variant="subtitle3">
                    {detail.fechaCreacion ? new Date(detail.fechaCreacion).toLocaleString() : '---'}
                  </Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckSujetosObligados

/* import { Box, Typography, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckSujetosObligados = ({ title = '', sujetosObligadosCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = sujetosObligadosCheck?.checkDetails?.results

  return (
    <Box className="detail-group" sx={{ padding: '2rem' }}>
      <Typography variant={variantByLevel[level] || variantByLevel[0]} sx={{ marginBottom: '1.5rem' }}>
        {title || t('common:sujetosObligados')}
      </Typography>

      <CheckDetailTitle
        email={sujetosObligadosCheck?.email}
        status={sujetosObligadosCheck?.status}
        createdAt={sujetosObligadosCheck?.createdAt}
        updatedAt={sujetosObligadosCheck?.updatedAt}
      />

      <Typography variant="h4" sx={{ fontSize: '1.25rem', marginBottom: '1rem' }}>
        Resultados
      </Typography>

      {details && details.length > 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '1.5rem',
          }}
        >
          {details.map((detail, index) => (
            <Box
              key={index}
              sx={{
                padding: '1.5rem',
                border: '0.1rem solid',
                borderColor: 'grey.300',
                borderRadius: '0.8rem',
                minWidth: '25rem',
                maxWidth: '30rem',
                flex: '1',
                backgroundColor: 'grey.50',
              }}
            >
              <Typography variant="body1" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>CUIT:</strong> {detail.cuit ?? '---'}
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Tipo Sujeto:</strong> {detail.tipoSujeto ?? '---'}
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Estado:</strong> {detail.estado ?? '---'}
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                <strong>Mensaje:</strong> {detail.mensaje ?? '---'}
              </Typography>
              <Typography variant="body1" sx={{ fontSize: '1rem' }}>
                <strong>Fecha Creación:</strong> {new Date(detail.fechaCreacion).toLocaleString() || '---'}
              </Typography>
              <Divider sx={{ marginTop: '1rem' }} />
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body1" sx={{ fontSize: '1rem', marginTop: '1rem' }}>
          {sujetosObligadosCheck?.checkDetails?.info}
        </Typography>
      )}
    </Box>
  )
}

export default CheckSujetosObligados
 */
